<template>

    <div>

        <template v-if="itemName === 'id'">
            {{ value }}
        </template>

        <!-- Custom Fields in table View -->
        <template v-else-if="['CUSTOM_CELL'].includes(itemType)">
          <div
            v-if="entity_field.name === 'chat_closed_by_timeout'"
            class="text-center"
          >{{value === entity_field.name ? $t('modules.op.common.yes') : $t('modules.op.common.no') }}</div>

          <div
            v-if="entity_field.name === 'accepted'"
            class="text-center"
          >{{value ? $t('modules.op.common.accepted') : $t('modules.op.common.no_accepted') }}</div>

          <div
            v-if="entity_field.name === 'last_answered_by_client'"
            class="text-center"
          >{{value === null
            ? ''
            : value
              ? $t('modules.op.common.client')
              : $t('modules.op.common.operator')
            }}</div>

          <div
            v-if="entity_field.name === 'csat'"
            class="text-center"
          >{{value}}</div>

        </template>
        <!-- end Custom Fields in table View -->

        <template v-else-if="is_association">
            <v-autocomplete
                v-tooltip="item_value?.label || item_value?.name || null"
                dense
                solo
                flat
                hide-details
                attach
                :background-color="getColorSelect || 'transparent'"
                class="colored_select"
                :class="{'non-editable': !canSave}"
                append-icon=""
                :item-text="(item) => item.label || item.name"
                item-value="id"
                v-model="item_value"
                :items="custom_data_linked_tables_values[association_model_name || itemName]"
                :menu-props="{minWidth:'200'}"
                @change="triggerChangeAssociation($event)"
                :readonly="!canSave || itemAssociation.non_editable"
            >
              <template v-slot:item="data">
                <span :style="{'background-color': data.item.color}">
                  {{data.item.label || data.item.name}}
                </span>
              </template>
            </v-autocomplete>
        </template>

        <template v-else>

          <!-- SLA metrics in table -->
          <template v-if="['SLA'].includes(itemType)">
            <!-- Paused SLA -->
            <v-chip
              v-if="value && value.is_paused"
              label
              outlined
              color="warning"
              small
            >
              <v-layout :align-center="true">
                <span>{{$t('modules.op.sla.paused')}}</span>
                <v-icon
                  size="20"
                  class="my-0"
                  right
                  color="warning"
                >
                  mdi-pause-circle
                </v-icon>
              </v-layout>
            </v-chip>

            <!-- Regular SLA -->
            <v-chip
              v-else-if="value"
              label
              outlined
              small
              :color="
                value.expiration <= new Date()
                ? value.is_expired
                  ? 'error'
                  : 'success'
                :'gray'
              "
            >
              <v-layout
                :align-center="true"
              >
                <div class="d-none">{{item_obj}}</div>
                <span>{{ value.expiration | formatDateTime }}</span>

                <v-icon
                  size="20"
                  class="my-0"
                  right
                  :color="
                    value.expiration <= new Date()
                      ? value.is_expired
                        ? 'error'
                        : 'success'
                      :'black'
                  "
                  v-text="
                    value.expiration <= new Date()
                    ? value.is_expired
                      ? 'mdi-close-octagon'
                      : 'mdi-check-decagram'
                    : 'mdi-timer-sand'
                  "
                />
              </v-layout>
            </v-chip>
          </template>
          <!-- end SLA metrics in table -->

          <!-- STRING, TEXT, FLOAT FIELDS -->
          <div
            v-else-if="['STRING'].includes(itemType) && headerData.string_input"
            class="calendar-cell"
            style="position: relative;"
          >
            <date-picker
              v-model.trim="item_value_date"
              :type="headerData.string_input.type"
              :valueType="headerData.string_input.format"
              :format="headerData.string_input.format"
              :show-second="false"
              :lang="$i18n.locale"
              :editable="!canSave || (readonlyMode || itemEditable)"
              :append-to-body="false"

              :disabled="checkDisableValidations(entity_field)"
              :disabled-date="(item) => checkDateValidations(item, entity_field)"
              :disabled-calendar-changer="(item) => checkDateValidations(item, entity_field)"
              :disabled-time="(item) => checkTimeValidations(item, entity_field)"
              :clearable="checkClearableValidations(entity_field)"
            />
          </div>


            <div
              v-else-if="['STRING', 'TEXT', 'FLOAT', 'INTEGER', 'BIGINT'].includes(itemType)"
              style="position: relative;"
            >
              <v-text-field
                v-tooltip="{
                  content: formatTooltipText(value),
                  html: this.typeFromStyle === 'json',
                  trigger: this.typeFromStyle === 'json' ? 'click' : 'hover',
                }"
                :append-icon="fieldIcon()"
                :value="value"
                solo
                :readonly="!canSave || (readonlyMode || itemEditable)"
                :class="{'non-editable': itemEditable || !canSave, 'is-link': itemDisplayType === 'link', 'is-open': itemClickAction === 'open'}"
                hide-details
                :background-color="highlight_color || 'transparent'"
                flat
                single-line
                dense
                @click:append="triggerClick()"
                @click="triggerClick()"
                @blur="triggerChangeOnBlur($event)"
                ref="refInputValue"
              />
            </div>

            <!-- BOOL FIELDS -->
            <v-checkbox
                v-else-if="['BOOLEAN'].includes(itemType)"
                v-model="item_value_checkbox"
                hide-details
                class="ma-0 pa-0"
                :readonly="!canSave || itemEditable"
                :ripple="false"
            ></v-checkbox>

            <!-- DATE FIELDS -->
            <template
                v-else-if="['DATE'].includes(itemType)"
            >

              <v-chip
                v-if="itemName === 'createdAt'"
                v-tooltip="value ? formatDate(value) : null"
                outlined
              >
                  {{ formatDate(value, true) }}
              </v-chip>

                <div 
                    v-else
                    class="calendar-cell"
                    style="position: relative;"
                >

                    <v-menu
                        :close-on-content-click="true"
                        transition="scale-transition"
                        attach
                        :disabled="!canSave"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                dense
                                solo
                                flat
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                hide-details
                                background-color="transparent"
                                :value="formatDate(item_value_date, true)"
                                :class="{'non-editable': !canSave}"
                                @input="triggerChange($event)"
                            ></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="item_value_date"
                            no-title
                            :locale="i18n.locale"
                            scrollable
                        >
                        </v-date-picker>
                    </v-menu>
                </div>
            </template>

          <template
            v-else-if="
              entity_field?.type === 'SELECT'
              && entity_field?.options?.length
            "
          >
            <v-autocomplete
              v-tooltip="value || ''"
              dense
              solo
              flat
              hide-details
              attach
              :class="{ 'non-editable': itemEditable || !canSave }"
              append-icon=""
              :item-text="(item) => item?.label || item?.value || item"
              v-model="value"
              :items="entity_field.options || []"
              :menu-props="{minWidth:'200'}"

              :readonly="!canSave || (readonlyMode || itemEditable)"
            />
          </template>

          <template v-else>
            {{value}}
          </template>

        </template>
    </div>
</template>

<script>
import i18n from "@/lang/i18n";
import {mapGetters} from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/de';
import HELPERS from "@/modules/OperatorPanel/helpers";

export default {
  name: "DynamicTableCell",

  components: {
    DatePicker,
  },

  props: {
    item_obj: {
      type: Object,
      default: () => {},
    },
    entity_field: {
      type: Object,
      default: () => {},
    },
    entity_fields: {
      type: Object,
      default: () => {},
    },
      itemId: {
          type: Number
      },
      itemName: {
          type: String
      },
      value: {
          type: [ String, Number, Array, Object, Boolean ],
          default: ''
      },
      itemType: {
          type: String
      },
      itemEditable: {
          type: Boolean,
          default: false
      },
      itemDisplayType: {
          type: String
      },
      itemClickAction: {
          type: String
      },
      itemAssociation: {
        type: Object
      },

      highlight_color: {
        type: String
      },

      headerData: {
        type: Object,
        default: () => {},
      },

    table_is_editable: {
      type: Boolean,
      default: true
    },
  },

    data: () => ({
        i18n,
        readonlyMode: true
    }),

  filters: {
    formatDateTime(dateStr) {
      return HELPERS.formatRelativeDateTime(dateStr, new Date());
    },
  },

    computed: {
      ...mapGetters([
        'user',
        'custom_data_linked_tables_values',
      ]),

      item_value: {
        get: function() {
          const arr = this.custom_data_linked_tables_values[this.association_model_name || this.itemName]
          return arr.find((i) => {
            let findBy =
              this.itemAssociation?.find_by
                ? i?.[this.itemAssociation?.find_by]
                : i.name

            if ( findBy === this.value) return i
          })
        },
        set: function(val){
          this.triggerChange(val)
        }
      },

      getColorSelect() {
        return this.item_value?.color || false
      },

      is_association() {
        if(this.itemAssociation){
          return !!this.custom_data_linked_tables_values?.[this.itemAssociation.name];
        }else {
          return !!this.custom_data_linked_tables_values?.[this.itemName];
        }
      },

        item_value_date: {
            get: function() {
                return this.value
            },
            set: function(val){
                this.triggerChange(val)
            }
        },

        item_value_checkbox: {
            get: function() {
                return this.value
            },
            set: function(val){
                this.triggerChange(val)
            }
        },

        canSave() {
          const routeName = this.$route?.name
          let permissionByRoute = null

          switch(routeName) {
            case 'Models': //Custom Data
              permissionByRoute = this.user.role.permissions.custom_data.sections.custom_data.canSave
              break;
            case 'BroadcastUsersUsers':
              permissionByRoute = this.user.role.permissions.broadcastUsers.route.haveRights
              break;
            default:
              permissionByRoute = this.user.role.permissions.custom_data.sections.custom_data.canSave;
              break;
          }

          return this.user && permissionByRoute && this.table_is_editable;
        },

      association_model_name() {
        return this.itemAssociation?.name || null
      },

      typeFromStyle() {
        return this.headerData?.style
      }
    },

    methods: {
        triggerClick() {
            this.readonlyMode = false;

            if (this.itemDisplayType === 'link') {
                window.open(this.addHttpIfMissing(this.value));
            }

            if (this.itemClickAction === 'open') {
                this.$emit('open-edit', this.itemId);
            }
        },

      triggerChangeAssociation(value) {
        const field = this.itemAssociation

        if(field?.auto_select_associated_on_change?.length){
          for(const i in field?.auto_select_associated_on_change){
            const index = this.findIndexWithAttr(
                this.custom_data_linked_tables_values[this.association_model_name || this.itemName],
              'name',
              value
            )

            if(
              index >= 0 &&
              this.custom_data_linked_tables_values[field.auto_select_associated_on_change[i]]
            ) {
              const val = this.custom_data_linked_tables_values[field.auto_select_associated_on_change[i]]
                .find((item) => item.is_id === this.custom_data_linked_tables_values[this.association_model_name][index]?.is_id)?.name

              const request = {
                [field.auto_select_associated_on_change[i]]: val || '',
                id: this.itemId,
              }

              if(this.$route?.name === 'Models')
                this.$root.$emit('CustomDataTab', request)
            }
          }
        }
      },

      findIndexWithAttr(array, attr, value) {
        for(let i = 0; i < array.length; i += 1) {
          if(array[i][attr] === value) {
            return i;
          }
        }
        return -1;
      },

        async triggerChange(value) {
          // get source name for association fields
          const request = {
            [this.itemAssociation?.name || this.itemName]: value,
            id: this.itemId
          }

          //save edit for Custom Data
          if(this.$route?.name === 'Models')
            await this.$root.$emit('CustomDataTab', request)

          //save edit for BroadcastUsersUsers
          if(this.$route?.name === 'BroadcastUsersUsers' && request?.id)
            await this.$root.$emit('BroadcastUsersUsers', request)
        },

      async triggerChangeOnBlur(event) {
        let value = event?.target?.value
        let originalValue = this.value

        if(value?.toString() !== originalValue?.toString()) {
          if(typeof this.value === 'number' && value) value = Number(value);

          // get source name for association fields
          const request = {
            [this.itemAssociation?.name || this.itemName]: value,
            id: this.itemId
          }

          //save edit for Custom Data
          if(this.$route?.name === 'Models')
            await this.$root.$emit('CustomDataTab', request)

          //save edit for BroadcastUsersUsers
          if(this.$route?.name === 'BroadcastUsersUsers')
            await this.$root.$emit('BroadcastUsersUsers', request)

          this.$refs.refInputValue.lazyValue = this.value;
        }
      },

        formatDate(isoTimeString, short = false, shortest = false) {
            if (!isoTimeString) return;
            const date = new Date(isoTimeString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            if (short) {
                return `${day}.${month}.${year.toString().slice(-2)} ${hours}:${minutes}`;
            } else if (shortest) {
                return `${day}.${month}.${year}`;
            } else {
                return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
            }
        },

        addHttpIfMissing(url) {
            if (!url.startsWith("http://") && !url.startsWith("https://")) {
                url = "http://" + url;
            }
            return url;
        },

        fieldIcon() {
            return this.itemClickAction === 'open' ? 'mdi-menu-open' : this.itemDisplayType === 'link' && this.value ? 'mdi-open-in-new' : '';
        },

      checkDateValidations(date, field) {
        let disabled = false

        if(
          field?.validate?.rules?.type === 'date'
          && !field?.validate?.rules?.ignore_in_table
        ) {
          const timeString = this.item_obj?.[field?.validate?.rules?.val_from_field];
          const now = timeString ? new Date(timeString) : new Date();
          const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0 , 0);
          const timestamp = d.getTime();
          const compare = this.$getComparator(field?.validate?.rules?.action)

          if(compare(date.getTime(), timestamp) ) disabled = true
        }

        return disabled
      },

      checkTimeValidations(date, field) {
        let disabled = false

        if(
          field?.validate?.rules?.type === 'time'
          && field?.validate?.rules?.action
          && !field?.validate?.rules?.ignore_in_table
        ) {
          let hours = 0, minutes = 0;
          const now = new Date();
          let timeString = this.item_obj?.[field?.validate?.rules?.val_from_field];

          if(timeString) {
            //fix if chosen date is not Today
            if(
              this.entity_fields?.[field?.validate?.rules?.val_from_field]
                ?.validate?.rules?.type === 'date'
            ) {
              if(this.isToday(timeString)) {
                timeString = `${now.getHours()}:${now.getMinutes()}`
              } else {
                timeString = '00:00'
              }
            }

            [hours, minutes] = timeString.split(':').map(Number);
          } else if(!field?.validate?.rules?.val_from_field) {
            hours = now.getHours();
            minutes = now.getMinutes();
          }

          const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
          const timestamp = d.getTime();
          const compare = this.$getComparator(field?.validate?.rules?.action)

          if(compare( timestamp, date.getTime() )) disabled = true
        }

        return disabled
      },

      checkClearableValidations(field) {
        let clearable = true

        if(field?.validate?.disable_clearable) {
          const required_field = field?.validate?.disable_clearable?.required_field

          if(
            required_field
            && this.item_obj?.[required_field]
          ) clearable = false
        }

        return clearable

      },

      //based on disable_clearable
      checkDisableValidations(field) {
        let disabled = false

        if(field?.validate?.required_field_empty) {
          //val from another field
          const val = this.item_obj[field?.validate?.required_field_empty]
          if(!val) disabled = true
        }
        if(field?.validate?.required_field_not_empty) {
          //val from another field
          const val = this.item_obj[field?.validate?.required_field_not_empty]
          if(val) disabled = true
        }

        if(
          field?.validate?.disabled_in_table_on_edit === true
          && this.value
        ) disabled = true

        return disabled
      },


      isToday(dateString) {
        const [day, month, year] = dateString.split('.').map(Number);
        const givenDate = new Date(year, month - 1, day);

        const today = new Date();
        return givenDate.getDate() === today.getDate() &&
          givenDate.getMonth() === today.getMonth() &&
          givenDate.getFullYear() === today.getFullYear();
      },

      formatTooltipText(text) {
        if(text) {
          if(this.typeFromStyle === 'json') {
            try {
              const parsed_json = JSON.parse(text)
              if(parsed_json) {
                text = Object.keys(parsed_json).map((key) => {
                  return `${key}: ${JSON.stringify(parsed_json[key])}`
                }).join('<br />')
              }
            } catch(e) {
              console.log(e, 'error Parse formatTooltipText')
            }
          }

          return text
        } else {
          return null
        }
      },
    }
}

</script>

<style scoped lang="scss">
    .v-input::v-deep {

      &.v-input--checkbox{
        display: flex;
        align-items: center;
        justify-content: center;

        .v-input__control {
          width: auto;
          flex-grow: unset;
        }
      }

        &:not(.non-editable) {
            transition: all 0.25s;
            border: 1px solid transparent;

            &:hover:not(.v-input--checkbox) {
                background-color: var(--v-primaryLight-base);
            }

            &.v-input--is-focused {
                border-color: var(--v-blueHaze-base);
            }
        }

        &.is-link,
        &.is-open {
            .v-input__slot, input {
                cursor: pointer;
            }

            .v-input__icon {
                opacity: 0;
                transition: all 0.25s;
            }

            &:hover {
                .v-input__icon {
                    opacity: 1;
                }
            }
        }

        &.is-link {
            .v-icon {
                font-size: 22px;
            }
        }

    }

  .colored_select::v-deep {

    .v-list {
        padding: 0;
    }

    .v-list-item {
      padding: 0;

      & > span {
        padding: 0 16px;
        width: 100%;
        min-height: 40px;
        display: flex;
        align-items: center;
      }
    }

    .v-list-item--link:before {
        opacity: 0 !important;
    }
  }

    .calendar-cell ::v-deep {
        table {
            border-top: 1px solid var(--v-blueHaze-base) !important;

            th {
                border-top: none;
            }
        }
    }
</style>